import { constant } from '@config/BaseSetting';
import useLocalStorage from '@hooks/useLocalStorage';
import { useGetAuditLogsObjectsMutation } from '@services/WebApiService/AuditLogApi';
import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';
import ITAutocomplete from '@ui/Components/ITAutocomplete';

const SEARCH_DELAY_MS = 500;

export default function ObjectsFilterSection({ partnerId, value, onChange }) {
  const [accessTokenSet] = useLocalStorage(constant.ACCESS_TOKEN_STORAGE);
  const [getAuditLogsObjects, getAuditLogsObjectsState] = useGetAuditLogsObjectsMutation();
  const [searchTimeoutHandle, setSearchTimeoutHandle] = useState();

  const handleOpen = () => {
    getAuditLogsObjects({
      accessToken: accessTokenSet,
      params: {
        distributor_id: partnerId,
      },
    });
  };

  const handleClose = () => {
    getAuditLogsObjectsState.reset();
  };

  const handleSearchChange = (searchText, open) => {
    clearTimeout(searchTimeoutHandle);
    if (!open) return;
    const newHandle = setTimeout(() => {
      getAuditLogsObjectsState.reset();
      getAuditLogsObjects({
        accessToken: accessTokenSet,
        params: {
          distributor_id: partnerId,
          q: searchText,
        },
      });
    }, SEARCH_DELAY_MS);
    setSearchTimeoutHandle(newHandle);
  };

  const options = useMemo(
    () => getAuditLogsObjectsState.data?.objects ?? [],
    [getAuditLogsObjectsState.data]
  );

  const loading = getAuditLogsObjectsState.isUninitialized || getAuditLogsObjectsState.isLoading;

  return (
    <ITAutocomplete
      multiple
      disableCloseOnSelect
      options={options}
      value={value}
      onChange={onChange}
      label="Objects"
      placeholder="Select Objects"
      loading={loading}
      onOpen={handleOpen}
      onClose={handleClose}
      onSearchChange={handleSearchChange}
      getOptionLabel={(option) => option.object_name}
      getOptionIdentifier={(option) => option.object_uid}
      filterOptions={false}
    />
  );
}

ObjectsFilterSection.propTypes = {
  partnerId: PropTypes.number,
  value: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func,
};

ObjectsFilterSection.defaultProps = {
  partnerId: 0,
  value: '',
  onChange: () => {},
};
